import { useCallback } from 'react';
import moment from 'moment';
import { Text } from 'v3/components';
import {
  validateRequiredPoints,
  validateSequentialDates,
  validateWaypointLimit,
} from '../Validation';
import { hasInvalidDateFields } from '../utils/routeMachineCard';

export function useRouteMachineValidation({ visiblePoints = [], snackbar }) {
  return useCallback(
    ({ showErrors = true } = {}) => {
      const missingDatePoints = visiblePoints.filter(hasInvalidDateFields);

      if (missingDatePoints.length > 0) {
        if (showErrors) {
          snackbar.show(
            <Text>
              Existem pontos com datas inválidas ou não preenchidas.
            </Text>,
            { type: 'error' },
          );
        }
        return false;
      }

      const waypointValidation = validateWaypointLimit(visiblePoints);
      if (!waypointValidation.isValid) {
        if (showErrors) {
          snackbar.show(<Text>{waypointValidation.message}</Text>, { type: 'error' });
        }
        return false;
      }

      const requiredValidation = validateRequiredPoints(visiblePoints);
      if (!requiredValidation.isValid) {
        if (showErrors) {
          snackbar.show(<Text>{requiredValidation.message}</Text>, { type: 'error' });
        }
        return false;
      }

      const invalidDateIndexes = validateSequentialDates(visiblePoints);
      if (invalidDateIndexes.length > 0) {
        if (showErrors) {
          const messages = invalidDateIndexes.map(index => {
            const prevPoint = visiblePoints[index - 1];
            const currentPoint = visiblePoints[index];

            const prevEndDate = moment(prevPoint?.scheduled_time).format('DD/MM/YYYY HH:mm');
            const currentStartDate = moment(currentPoint?.start_schedule).format('DD/MM/YYYY HH:mm');
            const prevLabel = `#${index} ${prevPoint?.name || 'Ponto anterior'}`;
            const currentLabel = `#${index + 1} ${currentPoint?.name || 'Ponto atual'}`;

            return `❌ ${currentLabel}: a data de início (${currentStartDate}) não pode ser anterior à data máxima do ${prevLabel} (${prevEndDate}).`;
          });

          snackbar.show(<Text>{messages.join('\n')}</Text>, { type: 'error' });
        }
        return false;
      }

      return true;
    },
    [visiblePoints, snackbar],
  );
}

export default useRouteMachineValidation;